import { Dropdown, Menu } from 'antd';
import cx from 'classnames';
import { observer } from 'mobx-react';
import React from 'react';
import { Link } from 'react-router-dom';
import { Icon, Table, TableBody } from 'semantic-ui-react';

import customFetch from '../../../utils/customFetch';
import iframe from '../../dashboard-routes/Iframe/iframeData';
import { TableEmptyMessage, TableFooterPagination, TableHeader } from '../../shared/table';
import * as api from '../../../stores/api';
import TypeOfClaimsStore from './TypeOfClaimsStore';
import router from '../../../stores/router';

const columns = [
  { title: '' },
  { title: 'ID', sortKey: 'Id' },
  { title: 'Name', sortKey: 'Name' },
  { title: 'Status', sortKey: 'IsActive' },
  { title: 'Description' },
];

@observer
class TypeOfClaimsTable extends React.Component {
  openCaseDetail = (id, name) => () => {
    localStorage.setItem('TypeOfClaims', name);
    iframe.forceOpenTab('PostTypesOfClaims', `?id=${id}&view=PostTypesOfClaims`, {
      id,
      view: 'PostTypesOfClaims',
    });
  };

  openModal = options => {
    return TypeOfClaimsStore.toggleModal(true, options);
  };

  handleDelete = id => async () => {
    TypeOfClaimsStore.setFieldsValue({ loading: true });

    try {
      await customFetch('/TypesOfClaims/DeleteRecord', {
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify({ id }),
      });
      await TypeOfClaimsStore.refetch({}, true);
    } finally {
      TypeOfClaimsStore.setFieldsValue({ loading: false });
    }
  };

  handleEditItemStatus = (id, record) => async () => {
    TypeOfClaimsStore.setFieldsValue({ loading: true });

    try {
      await customFetch('/TypesOfClaims/EditItemStatus', {
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify({ id, status: !record.IsActive }),
      });
      await TypeOfClaimsStore.refetch({}, true);
    } finally {
      TypeOfClaimsStore.setFieldsValue({ loading: false });
    }
  };

  onOpenCaseDetail = (record, id) => () => {
    localStorage.setItem('TypeOfClaims', record.Name);
    router.history.push({
      pathname: '/view/add-edit-types-of-claims-2',
      state: {
        type: 'typeOfClaim',
        record,
      },
      search: `?id=${id}`,
    });
  };

  renderTableBody = (data, colSpan) => {
    if (!data || !data.itemList.length) {
      return <TableEmptyMessage colSpan={colSpan} />;
    }

    return data.itemList.map(({ Id, ...record }) => (
      <Table.Row key={Id} negative={!record.IsActive}>
        {api.isAdmin() && <Table.Cell className="Cell-actions">{this.renderTableActions(Id, record)}</Table.Cell>}
        <Table.Cell>{Id}</Table.Cell>
        <Table.Cell
          selectable
          className={cx({ 'Cell-nowrap Cell-link': record.IsActive })}
          onClick={this.onOpenCaseDetail(record, Id)}
        >
          <Link
            onClick={this.onOpenCaseDetail(record, Id)}
            to={{
              pathname: '/view/add-edit-types-of-claims-2',
              state: {
                record,
                type: 'typeOfClaim',
              },
              search: `?id=${Id}`,
            }}
          >
            {record.Name}
          </Link>
        </Table.Cell>
        <Table.Cell>
          <p className={cx({ 'text-danger': !record.IsActive })}>{record.IsActive ? `Active` : `Inactive`}</p>
        </Table.Cell>
        <Table.Cell>{record.Description}</Table.Cell>
      </Table.Row>
    ));
  };

  renderTableActions = (id, record) => (
    <Dropdown
      trigger={['click']}
      overlay={
        <Menu>
          {record.IsActive === true ? (
            <Menu.Item onClick={this.onOpenCaseDetail(record, id)}>Edit</Menu.Item>
          ) : (
            <div></div>
          )}
          {!record.IsActive && (
            <Menu.Item
              onClick={this.openModal({
                modalType: 'confirm',
                message: 'Do you want to enable this item?',
                onOk: this.handleEditItemStatus(id, record),
              })}
            >
              Enable
            </Menu.Item>
          )}
          {record.IsActive && (
            <Menu.Item
              onClick={this.openModal({
                modalType: 'confirm',
                message: 'Do you want to disable this item?',
                onOk: this.handleEditItemStatus(id, record),
              })}
            >
              Disable
            </Menu.Item>
          )}
          <Menu.Item
            onClick={this.openModal({
              modalType: 'confirm',
              message: 'Do you want to delete this item?',
              onOk: this.handleDelete(id),
            })}
          >
            Delete
          </Menu.Item>
        </Menu>
      }
    >
      <Icon name="ellipsis vertical" />
    </Dropdown>
  );

  handlePageClick = page => {
    TypeOfClaimsStore.refetch({ curPage: page });
  };

  render() {
    const { data, loading, sortColumn, sortDirection } = TypeOfClaimsStore;
    const column = api.isAdmin() ? columns.map(i => i) : columns.filter(i => i.title !== '').map(i => i);
    const colSpan = column.length;
    return (
      <Table sortable striped celled className={cx({ disabled: loading })}>
        <TableHeader
          columns={column}
          sortColumn={sortColumn}
          sortDirection={sortDirection}
          onSort={TypeOfClaimsStore.handleSort}
        />
        <TableBody>{this.renderTableBody(data, colSpan)}</TableBody>
        <TableFooterPagination
          colSpan={colSpan}
          currentPage={TypeOfClaimsStore.curPage}
          totalPage={TypeOfClaimsStore.totalPage}
          totalItems={TypeOfClaimsStore.totalItems}
          onPageClick={this.handlePageClick}
        />
      </Table>
    );
  }
}

export default TypeOfClaimsTable;
